import { useState } from "react";
import apiClient from "../Helpers/apiClient";

function PdfGenerator() {
    const [quoteId, setQuoteId] = useState("");
    const [templateId, setTemplateId] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!quoteId || !templateId) {
            setError("Quote ID and Template ID are required.");
            setLoading(false);
            return;
        }

        try {
            const payload = {
                QuoteId: quoteId,
                TemplateId: templateId,
            };

            const response = await apiClient.post(
                "/api/dataverse/generate-pdf",
                payload,
                {
                    responseType: "blob", // Important for handling binary PDF response
                }
            );

            // Create a blob URL for the PDF and trigger download
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `quote-${quoteId}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log("PDF downloaded successfully");
        } catch (err) {
            console.error("Error generating PDF:", err);
            setError("Failed to generate PDF. Check the console for details.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
                <h1 className="text-2xl font-bold mb-4 text-center">
                    Generate PDF from Quote
                </h1>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Quote ID:
                        </label>
                        <input
                            type="text"
                            value={quoteId}
                            onChange={(e) => setQuoteId(e.target.value)}
                            placeholder="Enter Quote ID (e.g., e3a79da1-9b91-e811-8133-e0071b65ce81)"
                            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Template ID:
                        </label>
                        <input
                            type="text"
                            value={templateId}
                            onChange={(e) => setTemplateId(e.target.value)}
                            placeholder="Enter Template ID (e.g., 153dc496-d79d-e711-8109-e0071b65ce81)"
                            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-2 px-4 rounded-md text-white font-semibold ${
                            loading
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-blue-600 hover:bg-blue-700"
                        }`}
                    >
                        {loading ? "Generating PDF..." : "Generate PDF"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default PdfGenerator;
